import actionTypes from '../actionsFactory/types';
import { gwPost, gwGet } from '../actionsFactory/gwRequest';
import createBaseActions, { setPostBody } from '../actionsFactory';
import API_PATH from '../actionsFactory/apiPath';
import { Message } from '@bijie/react-bnb';

const { SET_RECHARGE_CURRENT_PRODUCT } = actionTypes;

const setRechargeCurrentPoduct = createBaseActions(SET_RECHARGE_CURRENT_PRODUCT, 'data');

export const getCurrentProduct = () => async dispatch => {
  try {
    const { success, data } = await gwGet(`${API_PATH.GET_RECHARGE_CURRENT_PRODUCT}`);
    if (success && data) dispatch(setRechargeCurrentPoduct(data));
  } catch (e) {}
};

export const getUserInfo = async productId => {
  try {
    var { data } = await gwGet(`${API_PATH.GET_RECHARGE_USER_INFO}?productId=${productId}`);
  } catch (e) {}
  return data;
};

export const getCurrentProgress = async productId => {
  try {
    var { data } = await gwGet(`${API_PATH.GET_RECHARGE_CURRENT_PROGRESS}?productId=${productId}`);
  } catch (e) {}
  return data;
};

export const getProdcutTier = async productId => {
  try {
    var { data } = await gwGet(`${API_PATH.GET_RECHARGE_PRODUCT_TIER}?productId=${productId}`);
  } catch (e) {}
  return data;
};

export const getDepositRecordList = async params => {
  try {
    var { data } = await gwPost(`${API_PATH.FETCH_RECHARGE_RECORD_LIST}`, setPostBody(params));
  } catch (e) {}
  return data;
};

export const getAllCoinNetwork = async () => {
  try {
    var { data } = await gwGet(`${API_PATH.GET_ALL_COIN_NETWORK}`);
  } catch (e) {}
  return data;
};

export const getNetworkAddress = async params => {
  try {
    var { data, success, message } = await gwPost(
      `${API_PATH.FETCH_RECHARGE_ADDRESS}`,
      setPostBody(params)
    );
  } catch (e) {}

  return data;
};
